

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Box, Typography, TextField, Button, IconButton, Avatar, useTheme, useMediaQuery,
// } from "@mui/material";
// import AttachFileIcon from "@mui/icons-material/AttachFile";
// import axios from "axios";
// import { io } from "socket.io-client";

// const API_URL = process.env.REACT_APP_API_URL;

// const avatarColor = (name = "") => {
//   const colors = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
//   let h = 0;
//   for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
//   return colors[Math.abs(h) % colors.length];
// };

// function Chat({ userId, username }) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const token = localStorage.getItem("token");
//   const [message, setMessage] = useState("");
//   const [messages, setMessages] = useState([]);
//   const [file, setFile] = useState(null);
//   const [typingUsers, setTypingUsers] = useState([]);
//   const [onlineUsers, setOnlineUsers] = useState([]);

//   const messagesEndRef = useRef(null);
//   const typingTimeoutRef = useRef();
//   const socketRef = useRef(null);

//   useEffect(() => {
//     if (!token) return;
//     socketRef.current = io(API_URL, { auth: { token }, transports: ["websocket"] });
//     socketRef.current.on("chatMessage", (data) => setMessages(prev => [...prev, data]));
//     socketRef.current.on("typing", (data) => {
//       if (data.username !== username)
//         setTypingUsers(prev => prev.includes(data.username) ? prev : [...prev, data.username]);
//     });
//     socketRef.current.on("stopTyping", (data) => setTypingUsers(prev => prev.filter(u => u !== data.username)));
//     socketRef.current.on("onlineUsers", setOnlineUsers);
//     return () => socketRef.current.disconnect();
//   }, [token, username]);

//   useEffect(() => {
//     if (!token) return;
//     axios.get(`${API_URL}/api/messages`, { headers: { Authorization: `Bearer ${token}` } })
//       .then(res => setMessages(res.data))
//       .catch(() => {});
//   }, [token]);

//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   const handleTyping = () => {
//     socketRef.current.emit("typing", { username });
//     clearTimeout(typingTimeoutRef.current);
//     typingTimeoutRef.current = setTimeout(() => {
//       socketRef.current.emit("stopTyping", { username });
//     }, 1500);
//   };

//   const sendMessage = () => {
//     if (!message.trim()) return;
//     socketRef.current.emit("chatMessage", {
//       userId, username, content: message.trim(), createdAt: new Date().toISOString()
//     });
//     setMessage("");
//     socketRef.current.emit("stopTyping", { username });
//   };

//   const sendFile = async () => {
//     if (!file) return;
//     const formData = new FormData();
//     formData.append("file", file);
//     try {
//       const res = await axios.post(`${API_URL}/api/upload`, formData, {
//         headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }
//       });
//       socketRef.current.emit("chatMessage", {
//         userId, username, content: "", fileUrl: res.data.fileUrl, createdAt: new Date().toISOString()
//       });
//       setFile(null);
//     } catch (err) {
//       console.error("File upload failed", err);
//     }
//   };

//   return (
//     <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#090C0F' }}>
//       {/* Sidebar */}
//       {!isMobile && (
//         <Box sx={{
//           width: 220, flexShrink: 0,
//           bgcolor: '#0E1318', borderRight: '1px solid #1A2228',
//           display: 'flex', flexDirection: 'column',
//           pt: 3, pb: 2, px: 2,
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 4, px: 1 }}>
//             <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#00C2B3' }} />
//             <Typography sx={{
//               fontFamily: "'Outfit', sans-serif", fontWeight: 600,
//               fontSize: 13, color: '#F0F4F8', letterSpacing: '0.04em', textTransform: 'uppercase',
//             }}>
//               Online ({onlineUsers.length})
//             </Typography>
//           </Box>

//           <Box sx={{ flex: 1, overflowY: 'auto' }}>
//             {onlineUsers.map(user => (
//               <Box key={user.id} sx={{
//                 display: 'flex', alignItems: 'center', gap: 1.5,
//                 px: 1.5, py: 1.2, borderRadius: '10px', mb: 0.5,
//                 bgcolor: user.id === userId ? '#0E2020' : 'transparent',
//                 border: user.id === userId ? '1px solid #0A3530' : '1px solid transparent',
//               }}>
//                 <Box sx={{ position: 'relative' }}>
//                   <Avatar sx={{
//                     width: 30, height: 30, fontSize: 12, fontWeight: 700,
//                     bgcolor: avatarColor(user.username),
//                   }}>
//                     {user.username?.[0]?.toUpperCase()}
//                   </Avatar>
//                   <Box sx={{
//                     position: 'absolute', bottom: 0, right: 0,
//                     width: 8, height: 8, bgcolor: '#00C2B3',
//                     borderRadius: '50%', border: '1.5px solid #0E1318',
//                   }} />
//                 </Box>
//                 <Typography sx={{
//                   fontFamily: "'Outfit', sans-serif", fontSize: 13,
//                   color: user.id === userId ? '#00C2B3' : '#A0B0BF',
//                   fontWeight: user.id === userId ? 600 : 400,
//                   overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
//                 }}>
//                   {user.username}{user.id === userId ? ' (you)' : ''}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       )}

//       {/* Main chat area */}
//       <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
//         {/* Header */}
//         <Box sx={{
//           px: 3, py: 2, bgcolor: '#0E1318', borderBottom: '1px solid #1A2228',
//           display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0,
//         }}>
//           <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#00C2B3' }} />
//           <Box>
//             <Typography sx={{
//               fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 16, color: '#F0F4F8',
//             }}>
//               Global Chat
//             </Typography>
//             <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#3A4A58' }}>
//               {typingUsers.length > 0
//                 ? `${typingUsers.join(', ')} ${typingUsers.length > 1 ? 'are' : 'is'} typing...`
//                 : `${onlineUsers.length} users online`}
//             </Typography>
//           </Box>
//         </Box>

//         {/* Messages */}
//         <Box sx={{
//           flex: 1, overflowY: 'auto', px: { xs: 2, sm: 3 }, py: 2,
//           display: 'flex', flexDirection: 'column', gap: 0.5,
//           '&::-webkit-scrollbar': { width: 4 },
//           '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
//           '&::-webkit-scrollbar-thumb': { bgcolor: '#1A2228', borderRadius: 4 },
//         }}>
//           {messages.map((msg, idx) => {
//             const prevMsg = idx > 0 ? messages[idx - 1] : null;
//             const isSameUser = prevMsg?.userId === msg.userId;
//             const withinFive = prevMsg ? new Date(msg.createdAt) - new Date(prevMsg.createdAt) < 300000 : false;
//             const hideHeader = isSameUser && withinFive;
//             const sent = msg.userId === userId;

//             return (
//               <Box key={idx} sx={{
//                 display: 'flex', justifyContent: sent ? 'flex-end' : 'flex-start',
//                 mb: hideHeader ? 0.3 : 1.5,
//                 mt: hideHeader ? 0 : sent ? 0 : 0,
//               }}>
//                 <Box sx={{ display: 'flex', flexDirection: sent ? 'row-reverse' : 'row', alignItems: 'flex-end', gap: 1, maxWidth: { xs: '80%', sm: '65%' } }}>
//                   {!hideHeader && !sent && (
//                     <Avatar sx={{
//                       width: 28, height: 28, fontSize: 11, fontWeight: 700,
//                       bgcolor: avatarColor(msg.username || ''),
//                       mb: 0.3, flexShrink: 0,
//                     }}>
//                       {(msg.username || '?')[0]?.toUpperCase()}
//                     </Avatar>
//                   )}
//                   {hideHeader && !sent && <Box sx={{ width: 28, flexShrink: 0 }} />}

//                   <Box sx={{
//                     bgcolor: sent ? '#0E2020' : '#0E1318',
//                     border: `1px solid ${sent ? '#0A3530' : '#1A2228'}`,
//                     borderRadius: sent
//                       ? (hideHeader ? '12px 4px 4px 12px' : '12px 4px 12px 12px')
//                       : (hideHeader ? '4px 12px 12px 4px' : '4px 12px 12px 12px'),
//                     px: 2, py: 1.2, minWidth: 80,
//                   }}>
//                     {!hideHeader && (
//                       <Typography sx={{
//                         fontFamily: "'Outfit', sans-serif", fontSize: 12, fontWeight: 600,
//                         color: sent ? '#00C2B3' : '#7A9BAA', mb: 0.4,
//                       }}>
//                         {sent ? 'You' : msg.username}
//                       </Typography>
//                     )}

//                     {msg.fileUrl ? (
//                       msg.fileUrl.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i) ? (
//                         <a href={`${API_URL}${msg.fileUrl}`} target="_blank" rel="noopener noreferrer">
//                           <img
//                             src={`${API_URL}${msg.fileUrl}`}
//                             alt="attachment"
//                             style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8, display: 'block' }}
//                           />
//                         </a>
//                       ) : (
//                         <a href={`${API_URL}${msg.fileUrl}`} target="_blank" rel="noopener noreferrer"
//                           style={{ color: '#00C2B3', textDecoration: 'none', fontSize: 14, fontFamily: "'Outfit', sans-serif" }}>
//                           📎 {msg.fileUrl.split("/").pop()}
//                         </a>
//                       )
//                     ) : (
//                       <Typography sx={{
//                         fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8', lineHeight: 1.5,
//                       }}>
//                         {msg.content}
//                       </Typography>
//                     )}

//                     {!hideHeader && (
//                       <Typography sx={{
//                         fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
//                         color: '#2A3A48', mt: 0.5, textAlign: sent ? 'right' : 'left',
//                       }}>
//                         {msg.createdAt ? new Date(msg.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
//                       </Typography>
//                     )}
//                   </Box>
//                 </Box>
//               </Box>
//             );
//           })}
//           <div ref={messagesEndRef} />
//         </Box>

//         {/* Input bar */}
//         <Box sx={{
//           px: 3, py: 2, bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
//           display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0,
//         }}>
//           <IconButton
//             component="label"
//             sx={{
//               width: 38, height: 38, borderRadius: '10px',
//               bgcolor: '#141B22', border: '1px solid #1A2228',
//               color: '#4A6070', flexShrink: 0,
//               '&:hover': { bgcolor: '#1A2530', color: '#00C2B3', borderColor: '#00C2B3' },
//             }}
//           >
//             <AttachFileIcon sx={{ fontSize: 18 }} />
//             <input type="file" hidden onChange={e => setFile(e.target.files[0])} />
//           </IconButton>

//           {file && (
//             <Button
//               onClick={sendFile}
//               variant="outlined"
//               size="small"
//               sx={{
//                 fontFamily: "'Outfit', sans-serif", fontSize: 12, textTransform: 'none',
//                 color: '#00C2B3', borderColor: '#00C2B3', borderRadius: '8px',
//                 py: 0.7, px: 1.5, flexShrink: 0, whiteSpace: 'nowrap',
//                 '&:hover': { bgcolor: '#0E2020' },
//               }}
//             >
//               Send file
//             </Button>
//           )}

//           <Box sx={{
//             flex: 1, bgcolor: '#141B22', border: '1px solid #1A2228',
//             borderRadius: '12px', display: 'flex', alignItems: 'center',
//             '&:focus-within': { borderColor: '#00C2B3' },
//           }}>
//             <TextField
//               multiline maxRows={4}
//               placeholder="Message #global..."
//               value={message}
//               onChange={e => { setMessage(e.target.value); handleTyping(); }}
//               onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
//               fullWidth
//               variant="standard"
//               InputProps={{ disableUnderline: true }}
//               sx={{
//                 px: 2, py: 1,
//                 '& .MuiInputBase-root': { fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8' },
//                 '& ::placeholder': { color: '#2A3A48' },
//               }}
//             />
//           </Box>

//           <Button
//             onClick={sendMessage}
//             disabled={!message.trim()}
//             sx={{
//               minWidth: 42, height: 42, borderRadius: '10px',
//               bgcolor: message.trim() ? '#00C2B3' : '#141B22',
//               border: `1px solid ${message.trim() ? '#00C2B3' : '#1A2228'}`,
//               color: message.trim() ? '#090C0F' : '#2A3A48',
//               flexShrink: 0, p: 0,
//               '&:hover': { bgcolor: message.trim() ? '#00D5C5' : '#1A2530' },
//               '&.Mui-disabled': { bgcolor: '#141B22', borderColor: '#1A2228' },
//             }}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//               <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//             </svg>
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// export default Chat;

import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box, Typography, TextField, Button, IconButton, Avatar,
  Tooltip, useTheme, useMediaQuery, Drawer,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { io } from "socket.io-client";
import { triggerNotification } from "./NotificationSystem";

const API_URL = process.env.REACT_APP_API_URL;

const avatarColor = (name = "") => {
  const c = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return c[Math.abs(h) % c.length];
};

const getAvatarUrl = (photo) => {
  if (!photo) return undefined;
  if (photo.startsWith('http')) return photo;
  return `${API_URL.replace(/\/+$/, '')}/${photo.replace(/^\/+/, '')}`;
};

const FilePreview = ({ fileUrl, apiUrl }) => {
  const url = `${apiUrl}${fileUrl}`;
  const name = fileUrl.split('/').pop();
  const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(fileUrl);
  const isVideo = /\.(mp4|mov|webm)$/i.test(fileUrl);
  const isAudio = /\.(mp3|wav|ogg)$/i.test(fileUrl);

  if (isImage) return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img src={url} alt={name} style={{ maxWidth: '100%', maxHeight: 220, borderRadius: 8, display: 'block', cursor: 'zoom-in' }} />
    </a>
  );
  if (isVideo) return <video src={url} controls style={{ maxWidth: '100%', borderRadius: 8 }} />;
  if (isAudio) return <audio src={url} controls style={{ width: '100%' }} />;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      style={{ color: '#00C2B3', textDecoration: 'none', fontFamily: "'Outfit', sans-serif", fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
      📎 {name}
    </a>
  );
};

function Chat({ userId, username }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const token = localStorage.getItem("token");

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [typingUsers, setTypingUsers] = useState([]);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [hoveredMsg, setHoveredMsg] = useState(null);

  const messagesEndRef = useRef(null);
  const typingTimeoutRef = useRef();
  const socketRef = useRef(null);
  const fileInputRef = useRef();

  // Connect socket
  useEffect(() => {
    if (!token) return;
    socketRef.current = io(API_URL, { auth: { token }, transports: ["websocket"] });

    socketRef.current.on("chatMessage", (data) => {
      setMessages(prev => [...prev, data]);
      // Notify if message is from someone else
      if (String(data.userId) !== String(userId)) {
        triggerNotification({ from: data.username, message: data.content || '📎 File' });
      }
    });

    socketRef.current.on("globalMessageDeleted", ({ messageId }) => {
      setMessages(prev => prev.filter(m => m._id !== messageId));
    });

    socketRef.current.on("typing", (data) => {
      if (data.username !== username)
        setTypingUsers(prev => prev.includes(data.username) ? prev : [...prev, data.username]);
    });

    socketRef.current.on("stopTyping", (data) => {
      setTypingUsers(prev => prev.filter(u => u !== data.username));
    });

    socketRef.current.on("onlineUsers", (users) => {
      setOnlineUsers(users.filter(u => String(u.id) !== String(userId)));
    });

    return () => socketRef.current?.disconnect();
  }, [token, username, userId]);

  // Load message history
  useEffect(() => {
    if (!token) return;
    axios.get(`${API_URL}/api/messages`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setMessages(res.data))
      .catch(() => {});
  }, [token]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleTyping = () => {
    if (!socketRef.current) return;
    socketRef.current.emit("typing", { username });
    clearTimeout(typingTimeoutRef.current);
    typingTimeoutRef.current = setTimeout(() => {
      socketRef.current?.emit("stopTyping", { username });
    }, 1500);
  };

  const handleFileSelect = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    if (f.type.startsWith('image/')) {
      setFilePreview(URL.createObjectURL(f));
    } else {
      setFilePreview(null);
    }
  };

  const clearFile = () => {
    setFile(null);
    setFilePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const sendFile = async () => {
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await axios.post(`${API_URL}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }
      });
      socketRef.current?.emit("chatMessage", {
        userId, username, content: "", fileUrl: res.data.fileUrl, createdAt: new Date().toISOString()
      });
      clearFile();
    } catch (err) {
      console.error("File upload failed", err);
    } finally {
      setUploading(false);
    }
  };

  const sendMessage = () => {
    if (!message.trim()) return;
    socketRef.current?.emit("chatMessage", {
      userId, username, content: message.trim(), createdAt: new Date().toISOString()
    });
    setMessage("");
    socketRef.current?.emit("stopTyping", { username });
  };

  const deleteMessage = (msgId) => {
    socketRef.current?.emit("deleteGlobalMessage", { messageId: msgId });
  };

  const onlineList = (
    <Box sx={{ width: { xs: 220, sm: 220 }, bgcolor: '#0E1318', height: '100%', pt: 2, px: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, px: 1 }}>
        <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 12, color: '#5A6A78', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Online — {onlineUsers.length}
        </Typography>
        {isMobile && <IconButton size="small" onClick={() => setSidebarOpen(false)} sx={{ color: '#5A6A78' }}><CloseIcon fontSize="small"/></IconButton>}
      </Box>
      {onlineUsers.map(user => (
        <Box key={user.id} sx={{
          display: 'flex', alignItems: 'center', gap: 1.5,
          px: 1.5, py: 1, borderRadius: '10px', mb: 0.5,
        }}>
          <Box sx={{ position: 'relative' }}>
            <Avatar
              src={getAvatarUrl(user.profilePhoto)}
              sx={{ width: 30, height: 30, fontSize: 11, fontWeight: 700, bgcolor: avatarColor(user.username) }}
            >
              {!user.profilePhoto && user.username?.[0]?.toUpperCase()}
            </Avatar>
            <Box sx={{ position: 'absolute', bottom: 0, right: 0, width: 8, height: 8, bgcolor: '#00C2B3', borderRadius: '50%', border: '1.5px solid #0E1318' }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#A0B0BF', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user.username}
            </Typography>
            {user.status && (
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 10, color: '#3A4A58', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user.status}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#090C0F', pt: '56px' }}>
      {/* Desktop sidebar */}
      {!isMobile && (
        <Box sx={{ width: 220, flexShrink: 0, borderRight: '1px solid #1A2228', overflowY: 'auto' }}>
          {onlineList}
        </Box>
      )}

      {/* Mobile sidebar drawer */}
      {isMobile && (
        <Drawer anchor="right" open={sidebarOpen} onClose={() => setSidebarOpen(false)}
          PaperProps={{ sx: { bgcolor: '#090C0F' } }}>
          {onlineList}
        </Drawer>
      )}

      {/* Main */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {/* Header */}
        <Box sx={{
          px: 3, py: 1.5, bgcolor: '#0E1318', borderBottom: '1px solid #1A2228',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0,
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#00C2B3' }} />
            <Box>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 15, color: '#F0F4F8' }}>
                # global
              </Typography>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#3A4A58' }}>
                {typingUsers.length > 0
                  ? `${typingUsers.slice(0, 2).join(', ')}${typingUsers.length > 2 ? '...' : ''} typing...`
                  : `${onlineUsers.length} users online`}
              </Typography>
            </Box>
          </Box>
          {isMobile && (
            <IconButton onClick={() => setSidebarOpen(true)} sx={{ color: '#5A6A78' }}>
              <PeopleAltOutlinedIcon fontSize="small" />
            </IconButton>
          )}
        </Box>

        {/* Messages */}
        <Box sx={{
          flex: 1, overflowY: 'auto', px: { xs: 1.5, sm: 3 }, py: 2,
          '&::-webkit-scrollbar': { width: 4 },
          '&::-webkit-scrollbar-thumb': { bgcolor: '#1A2228', borderRadius: 4 },
        }}>
          {messages.map((msg, idx) => {
            const prevMsg = idx > 0 ? messages[idx - 1] : null;
            const isSameUser = prevMsg?.userId === msg.userId;
            const withinFive = prevMsg
              ? new Date(msg.createdAt) - new Date(prevMsg.createdAt) < 300000
              : false;
            const hideHeader = isSameUser && withinFive;
            const sent = String(msg.userId) === String(userId);

            return (
              <Box
                key={msg._id || idx}
                onMouseEnter={() => setHoveredMsg(msg._id)}
                onMouseLeave={() => setHoveredMsg(null)}
                sx={{
                  display: 'flex',
                  justifyContent: sent ? 'flex-end' : 'flex-start',
                  mb: hideHeader ? 0.4 : 1.8,
                  mt: hideHeader ? 0 : 0,
                  position: 'relative',
                }}
              >
                <Box sx={{
                  display: 'flex',
                  flexDirection: sent ? 'row-reverse' : 'row',
                  alignItems: 'flex-end',
                  gap: 1,
                  maxWidth: { xs: '85%', sm: '65%' },
                }}>
                  {/* Avatar */}
                  {!sent && (
                    hideHeader
                      ? <Box sx={{ width: 28, flexShrink: 0 }} />
                      : (
                        <Avatar
                          src={getAvatarUrl(msg.profilePhoto)}
                          sx={{ width: 28, height: 28, fontSize: 11, fontWeight: 700, bgcolor: avatarColor(msg.username), mb: 0.3, flexShrink: 0 }}
                        >
                          {!msg.profilePhoto && msg.username?.[0]?.toUpperCase()}
                        </Avatar>
                      )
                  )}

                  {/* Bubble */}
                  <Box sx={{
                    bgcolor: sent ? '#0E2020' : '#0E1318',
                    border: `1px solid ${sent ? '#0A3530' : '#1A2228'}`,
                    borderRadius: sent
                      ? (hideHeader ? '12px 4px 4px 12px' : '12px 4px 12px 12px')
                      : (hideHeader ? '4px 12px 12px 4px' : '4px 12px 12px 12px'),
                    px: 2, py: 1.2,
                  }}>
                    {!hideHeader && (
                      <Typography sx={{
                        fontFamily: "'Outfit', sans-serif", fontSize: 12, fontWeight: 600,
                        color: sent ? '#00C2B3' : '#7A9BAA', mb: 0.4,
                      }}>
                        {sent ? 'You' : msg.username}
                      </Typography>
                    )}
                    {msg.fileUrl
                      ? <FilePreview fileUrl={msg.fileUrl} apiUrl={API_URL} />
                      : (
                        <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8', lineHeight: 1.5, wordBreak: 'break-word' }}>
                          {msg.content}
                        </Typography>
                      )
                    }
                    {!hideHeader && (
                      <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: '#2A3A48', mt: 0.5, textAlign: sent ? 'right' : 'left' }}>
                        {msg.createdAt ? new Date(msg.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                      </Typography>
                    )}
                  </Box>

                  {/* Delete button */}
                  {sent && msg._id && hoveredMsg === msg._id && (
                    <Tooltip title="Delete" placement="top">
                      <IconButton
                        size="small"
                        onClick={() => deleteMessage(msg._id)}
                        sx={{
                          color: '#FF6B6B', p: 0.3,
                          '&:hover': { bgcolor: '#1A0E0E' },
                        }}
                      >
                        <DeleteOutlineIcon sx={{ fontSize: 15 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Box>
            );
          })}

          {typingUsers.length > 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1, mb: 1 }}>
              <Box sx={{ display: 'flex', gap: 0.4 }}>
                {[0, 1, 2].map(i => (
                  <Box key={i} sx={{
                    width: 5, height: 5, borderRadius: '50%', bgcolor: '#00C2B3',
                    animation: `bounce 1.2s ${i * 0.2}s infinite`,
                    '@keyframes bounce': {
                      '0%, 100%': { transform: 'translateY(0)' },
                      '50%': { transform: 'translateY(-4px)' },
                    },
                  }} />
                ))}
              </Box>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#3A4A58' }}>
                {typingUsers[0]} is typing
              </Typography>
            </Box>
          )}
          <div ref={messagesEndRef} />
        </Box>

        {/* File preview strip */}
        {file && (
          <Box sx={{
            px: 3, py: 1.5, bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
            display: 'flex', alignItems: 'center', gap: 2,
          }}>
            {filePreview
              ? <img src={filePreview} alt="preview" style={{ height: 56, width: 56, objectFit: 'cover', borderRadius: 8 }} />
              : <Box sx={{ width: 56, height: 56, bgcolor: '#141B22', border: '1px solid #1A2228', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography sx={{ fontSize: 22 }}>📎</Typography>
                </Box>
            }
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#F0F4F8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {file.name}
              </Typography>
              <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: '#3A4A58' }}>
                {(file.size / 1024).toFixed(0)} KB
              </Typography>
            </Box>
            <Button
              onClick={sendFile}
              disabled={uploading}
              sx={{
                fontFamily: "'Outfit', sans-serif", fontSize: 12, textTransform: 'none',
                bgcolor: '#00C2B3', color: '#090C0F', borderRadius: '8px', px: 2, py: 0.8,
                '&:hover': { bgcolor: '#00D5C5' }, flexShrink: 0,
              }}
            >
              {uploading ? 'Sending...' : 'Send'}
            </Button>
            <IconButton onClick={clearFile} size="small" sx={{ color: '#FF6B6B' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        )}

        {/* Input bar */}
        <Box sx={{
          px: { xs: 1.5, sm: 3 }, py: 1.5,
          bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
          display: 'flex', alignItems: 'flex-end', gap: 1, flexShrink: 0,
        }}>
          <IconButton
            component="label"
            sx={{
              width: 38, height: 38, borderRadius: '10px',
              bgcolor: '#141B22', border: '1px solid #1A2228',
              color: '#4A6070', flexShrink: 0,
              '&:hover': { bgcolor: '#1A2530', color: '#00C2B3', borderColor: '#00C2B3' },
            }}
          >
            <AttachFileIcon sx={{ fontSize: 18 }} />
            <input type="file" hidden ref={fileInputRef} onChange={handleFileSelect} />
          </IconButton>

          <Box sx={{
            flex: 1, bgcolor: '#141B22', border: '1px solid #1A2228',
            borderRadius: '12px',
            '&:focus-within': { borderColor: '#00C2B3' },
          }}>
            <TextField
              multiline maxRows={5}
              placeholder="Message #global..."
              value={message}
              onChange={e => { setMessage(e.target.value); handleTyping(); }}
              onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
              fullWidth variant="standard"
              InputProps={{ disableUnderline: true }}
              sx={{
                px: 2, py: 1,
                '& .MuiInputBase-root': { fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8' },
                '& textarea::placeholder': { color: '#2A3A48', opacity: 1 },
              }}
            />
          </Box>

          <IconButton
            onClick={sendMessage}
            disabled={!message.trim()}
            sx={{
              width: 38, height: 38, borderRadius: '10px', flexShrink: 0,
              bgcolor: message.trim() ? '#00C2B3' : '#141B22',
              border: `1px solid ${message.trim() ? '#00C2B3' : '#1A2228'}`,
              color: message.trim() ? '#090C0F' : '#2A3A48',
              '&:hover': { bgcolor: message.trim() ? '#00D5C5' : '#1A2530' },
              '&.Mui-disabled': { bgcolor: '#141B22', borderColor: '#1A2228', color: '#2A3A48' },
            }}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

export default Chat;